/**
 * @index.tsx
 *
 * @fileoverview Mobile filters.
 */
import React from 'react';
import { Facet } from '~/jobiqo/models/search';
import { Drawer } from '~/vcl/molecules/04-navigation/02-drawer';
import { FacetTabs } from '../../facet-tabs';

export interface MobileFiltersProps {
  navOpened: boolean;
  setNavOpened: any;
  toggleNav: any;
  querystring: any;
  pathname: string;
  facets: Facet[];
  onFacetToggle: (
    name: string,
    selectedItems: string[],
    alias?: string,
  ) => void;
  getFacetSelectedItems(facet: Facet): string[];
  renderAdditionalTabs?: () => React.ReactNode;
  renderAdditionalTabPanels?: () => React.ReactNode;
}

export const MobileFilters = ({
  navOpened,
  setNavOpened,
  toggleNav,
  pathname,
  facets,
  querystring,
  onFacetToggle,
  getFacetSelectedItems,
  renderAdditionalTabs,
  renderAdditionalTabPanels,
}: MobileFiltersProps) => {
  return (
    <Drawer
      allowDrag={false}
      height="15rem"
      position="bottom"
      isOpen={navOpened}
      onToggle={(e) => toggleNav(navOpened, setNavOpened)}
    >
      <FacetTabs
        pathname={pathname}
        querystring={querystring}
        facets={facets}
        onFacetToggle={onFacetToggle}
        getFacetSelectedItems={getFacetSelectedItems}
        renderAdditionalTabs={renderAdditionalTabs}
        renderAdditionalTabPanels={renderAdditionalTabPanels}
      />
    </Drawer>
  );
};
export default MobileFilters;
